import { isDesktop, isMobile } from '@/lib/platform';

const SESSION_KEY = 'nula-client-id';
const LOCAL_KEY = 'nula-client-group-id';

let cachedClientId: string | null = null;
let cachedClientGroupId: string | null = null;

/** Per-tab identity — new per tab, stored in sessionStorage. */
export function getClientId(): string {
  if (cachedClientId) return cachedClientId;
  const stored = sessionStorage.getItem(SESSION_KEY);
  if (stored) {
    cachedClientId = stored;
    return stored;
  }
  const id = crypto.randomUUID();
  sessionStorage.setItem(SESSION_KEY, id);
  cachedClientId = id;
  return id;
}

/** Per-device identity — stable per browser, stored in localStorage. */
export function getClientGroupId(): string {
  if (cachedClientGroupId) return cachedClientGroupId;
  const stored = localStorage.getItem(LOCAL_KEY);
  if (stored) {
    cachedClientGroupId = stored;
    return stored;
  }
  const id = crypto.randomUUID();
  localStorage.setItem(LOCAL_KEY, id);
  cachedClientGroupId = id;
  return id;
}

/** Reset cached identity values. Call on logout so the next
 *  `getClientId()` / `getClientGroupId()` generates fresh UUIDs. */
export function resetClientIdentity(): void {
  cachedClientId = null;
  cachedClientGroupId = null;
}

/** Platform identifier for the wire protocol. Derives from the existing
 * `isDesktop`/`isMobile` flags in `@/lib/platform` (single source of truth for
 * platform detection — currently reads `VITE_PLATFORM` at build time). */
export const CLIENT_PLATFORM: 'web' | 'desktop' | 'mobile' =
  isDesktop ? 'desktop' : isMobile ? 'mobile' : 'web';
